import React from 'react'

const GetApp = () => {
  return (
    <div>GetApp</div>
  )
}

export default GetApp